import { definePlugin } from '../../code-plug';

import { SharedFormsSidebar } from './views/shared-form-sidebar';

definePlugin('dashboard-shared-forms', ({ registerView }, params) => {
  registerView('dashboard-sidebar', SharedFormsSidebar, params);
});
